
import { Trek } from '@/lib/types/trek-types';

/**
 * Map database schema to Trek frontend model
 */
export function mapDbSchemaToTrek(dbTrek: any): Trek {
  return {
    id: dbTrek.id,
    name: dbTrek.name,
    location: dbTrek.location,
    difficulty: dbTrek.difficulty as Trek['difficulty'],
    elevation: dbTrek.elevation,
    elevationUnit: dbTrek.elevation_unit as 'feet' | 'meters',
    distance: dbTrek.distance,
    bestSeason: dbTrek.best_season,
    description: dbTrek.description,
    images: dbTrek.images,
    isTopTrek: dbTrek.is_top_trek,
    duration: dbTrek.duration,
    itineraryHighlights: dbTrek.itinerary_highlights as Trek['itineraryHighlights'],
    is_active: dbTrek.is_active,
    priority: dbTrek.priority
  };
}

/**
 * Map Trek frontend model to database schema
 */
export function mapTrekToDbSchema(trek: Partial<Trek>) {
  return {
    id: trek.id,
    name: trek.name,
    location: trek.location,
    difficulty: trek.difficulty,
    elevation: trek.elevation,
    elevation_unit: trek.elevationUnit,
    distance: trek.distance,
    best_season: trek.bestSeason,
    description: trek.description,
    images: trek.images,
    is_top_trek: trek.isTopTrek,
    duration: trek.duration,
    itinerary_highlights: trek.itineraryHighlights,
    is_active: trek.is_active,
    priority: trek.priority
  };
}
